<template>
    <div class="tabs">
        <ul class="flex">
            <li class="mr-5" v-bind:key="tab.title" v-for="tab in tabs">
                <span href="#" class="cursor-pointer inline-block border-accent py-1 px-3 font-semibold"
                   @click.prevent="select(tab)"
                   v-bind:class="{'border-b-4': tab.active}"
                   v-text="tab.title"></span>
            </li>
        </ul>
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "Tabs",
        props: {
            defaultIndex: {
                default: 0,
                type: Number
            },
        },
        data() {
            return {
                selectedIndex: this.defaultIndex,
                tabs: [],
                tabs_titles: [],
            }
        },
        mounted() {
            this.tabs = this.$children;
        },
        methods: {
            select(selectedTab) {
                this.tabs.forEach(tab => {
                    tab.active = (tab.title === selectedTab.title)
                })
            }
        }
    }
</script>

<style scoped>

</style>